/**
 * This is users script.js file
 */

import TableList from '@/inheritance/table-list';

export default {
  /**
   * Nombre del componente
   */
  name: 'Users',

  /**
   * Extendemos la funcionalidad del listado de tablas desde src/inheritance/table-list.js
   */
  extends: TableList,

  /**
   * @override
   */
  data() {
    return {
      componentKey: 0,
      listSearching: false
    };
  },

  methods: {
    /**
     * Obtenemos la lista de usuarios desde el servicio
     * @param {String} sort Orden asc/desc
     * @param {Object} cfg Configuración de filtros
     */
    loadItems(sort = this.orderby, cfg = {}) {
      if (this.filters && Object.keys(this.filters).length) {
        cfg.params = {
          $filter: JSON.stringify(this.filters)
        };
      }
      const payload = {
        section: 'users',
        cfg
      };

      if (sort && sort !== 'false') {
        payload.sort = sort;
      }

      this.listSearching = true;
      this.loadData(payload)
        .then(res => {
          this.metadata = res.metadata;
          res.data.users = res.data.users
            .map(user => {
              const fieldsToDelete = ['password_recovery_token'];
              fieldsToDelete.forEach(field => delete user[field]);
              return user;
            })
            .filter(user => !['Process', 'RD', 'admin', 'Tester','b07db1d8-6e31-4925-9b8c-99b069da6935','admin@carbon.super'].includes(user.username));
          this.items = this.mapSelfName(res.data.users, ['given_name', 'family_name_1']);
          this.getColumns();
          this.filterColums();
          this.calculateColumnsWith(this.columns);
        })
        .catch(err => this.$toast.error(`Error ${err.name}`, `${err.message}`))
        .finally(() => {
          this.listSearching = false;

          this.$nextTick(() => {
            if (!this.tableHasScroll()) {
              this.infiniteScroll();
            }
          });
        });
    },
    /**
     * Ordenamos la tabla por un campo específico
     * @param {String} field Orden de la tabla
     */
    sort(field) {
      this.orderby = field;
      let cfg = {};
      if (this.filters && Object.keys(this.filters).length) {
        cfg = {
          params: {
            $filter: JSON.stringify(this.filters)
          }
        };
      }
      if (field && field !== 'false') {
        this.saveFilterInLocalstore(field, 'ob_usr');
      } else {
        this.removeFromLocalstore('ob_usr');
      }
      this.loadItems(field, cfg);
    },
    /**
     * Aplicamos los filtros seleccionados
     * @param {Array} filters Filtros para aplicar
     */
    filter(filters) {
      this.saveFilterInLocalstore(filters, 'filt_usr');
      if (filters.length >= 1) {
        this.tbFilters = filters;
        this.applyFilters(filters);
        const cfg = {
          params: {
            $filter: JSON.stringify(this.filters)
          }
        };
        this.loadItems(this.orderby, cfg);
      } else {
        delete this.filters;
        this.loadItems();
      }
    },
    /**
     * @override
     */
    infiniteScroll() {
      if (this.listSearching) {
        return;
      }
      const payload = {
        section: 'users',
        href: this.metadata.paging._links._next.href
      };
      if (payload.href && !this.isLoading) {
        this.pagination(payload)
          .then(res => {
            this.metadata = res.metadata;
            this.items = [...this.items, ...this.loadDataInTable(res.data.users, ['given_name', 'family_name_1'])];
          })
          .catch(err => this.$toast.error(`Error ${err.name}`, `${err.message}`));
      }
    },
    /**
     * @override
     */
    downloadExport(columns, format) {
      const payload = {
        section: 'users',
        headers: columns.map(x => x.name),
        cfg: {
          params: {
            // $filter: JSON.stringify(this.filters),
            $format: format,
            $offset: this.metadata.paging.offset,
            $limit: 0
          },
          responseType: 'blob'
        },
        sort: this.orderby
      };

      if (this.filters && Object.keys(this.filters).length) {
        payload.cfg.params['$filter'] = JSON.stringify(this.filters);
      }

      this.download(payload)
        .then(res => {
          const urlCreator = window.URL || window.webkitURL;
          this.filePreview = urlCreator.createObjectURL(res.data);
          this.fileType = res.type;
          this.fileName = `users.${format}`;
          const fileLink = document.createElement('a');
          fileLink.href = this.filePreview;
          fileLink.setAttribute('download', this.fileName);
          document.body.appendChild(fileLink);
          fileLink.click();
          fileLink.remove();
          window.addEventListener('focus', () => URL.revokeObjectURL(fileLink.href), { once: true });
          this.$toast.success(`Exportación completada`, `Descargado con éxito.`);
        })
        .catch(err => this.$toast.error(`Error ${err.name}`, `${err.message}`));
    },

    /**
     * @override
     */
    colsChange(cols) {
      this.columns = cols;
      this.saveFilterInLocalstore(cols, `col_usr`);
    },
    /**
     * Añade los filtros obtenidos de localStorage a la petición inicial
     * @param {Object} tbFilters filtros guardados en storage
     */
    addFiltersToRequest(tbFilters) {
      // Se añaden los filtros a la petición si están en el storage
      this.filters = [];
      tbFilters.forEach(filtro => {
        const condition = filtro.condition;
        this.filters.push({
          field: filtro.field,
          condition,
          conditionValue: filtro.conditionValue
        });
      });
      this.applyFilters(this.filters);
    },

    doSearch(val) {
      this.search = val;
      this.saveFilterInLocalstore(val, 'search_usr');
      this.loadItems();
    },

    filterColums() {
      this.columns = this.columns.filter(col => {
        return ![
          'facebook',
          'is_deleted',
          'instagram',
          'linkedin',
          '_links',
          'password_recovery_token',
          'photo',
          'recovery_requested_on',
          '_self_name',
          'telephone',
          'twitter',
          'uuid',
          'uuid_distributor',
          'uuid_group',
          'uuid_permission_set',
          'uuid_subdistributor'
        ].includes(col.field);
      });
    },

    handleLoadView(view) {
      this.filters = null;
      this.tbFilters = [];
      this.orderby = '';
      this.removeFromLocalstore('filt_usr');
      this.removeFromLocalstore('ob_usr');
      this.removeFromLocalstore('col_usr');
      this.removeFromLocalstore('search_usr');
      this.loadView(view);
    }
  },
  /**
   * @override
   */
  beforeMount() {
    this.section = 'users';
    this.loadSectionViews();
  },
  /**
   * Configuración inicial del componente
   * 1. Asignamos las columnas por defecto del listado de la tabla
   * 2. Obtenemos los filtros que el usuario pueda haber aplicado con anterioridad
   * 3. Obtenemos la información de la tabla
   */
  mounted() {
    this.defaultColumns = [
      'username',
      'given_name',
      'family_name_1',
      'family_name_2',
      'telephone',
      'photo',
      'department'
    ];
    this.tbFilters = this.loadFilterInLocalstore('filt_usr');
    this.orderby = this.loadFilterInLocalstore('ob_usr');
    this.search = this.loadFilterInLocalstore('search_usr');

    this.addFiltersToRequest(this.tbFilters);

    if (
      this.orderby &&
      this.orderby !== 'false' &&
      this.orderby.length > 0 &&
      this.orderby !== this.$route.query['sorts-by']
    ) {
      this.$router
        .replace({
          path: this.$route.fullPath,
          // query: { sort: this.orderby.split(' ')[0],  order: this.orderby.split(' ')[1] }
          query: { 'sorts-by': this.orderby }
        })
        .then(() => {
          this.sort(this.orderby);
        });
    } else {
      this.loadItems();
    }
    this.columns = this.loadFilterInLocalstore('col_usr');
  }
};
